import React from "react";
import { Box, Typography } from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import { strings } from "../../i18n";
import styles from "./styles";

/**
 *  Not Found Component
 */
export default ({ message }) => {
    const classes = makeStyles(styles)();
    return (
        <Box className={classes.messageContainer}>
            <Box className={classes.message}>
                <Typography variant="h4">404</Typography>
                <Typography variant="subtitle1">
                    {message && message.length > 0
                        ? message
                        : strings("notFound")}
                </Typography>
            </Box>
        </Box>
    );
};
